import HtmlNode from '../Extension/HtmlNode';
import InputError from './InputError';
import InputInformation from './InputInformation';
import { MarketCode } from '../../@types/MarketCode';
import { getRegistrationNumberIdentifier } from '../../Templates/RegistrationNumberIndetifier';

interface InputFieldEditProps {
  readonly title: string;
  readonly value: string;
  readonly name: string;
  readonly id: string;
  error?: boolean;
  errorMessage?: string;
  readonly placeholder?: string;
  readonly information?: string;
  readonly change?: string;
  readonly type?: string;
  readonly autocomplete?: string;
  readonly pattern?: string;
  readonly inputmode?: string;
  readonly disabled?: boolean;
  readonly readOnly?: boolean;
  readonly market?: MarketCode;
  readonly onChange?: (e: Event) => void;
  readonly onBlur?: (e: Event) => void;
  readonly onKeyDown?: (e: KeyboardEvent) => void;
  readonly onEdit?: (e: MouseEvent) => void;
}

class InputFieldEdit extends HtmlNode {
  private readonly props: InputFieldEditProps;
  private contexts: {
    error?: InputError;
  } = {};

  constructor(element: HTMLElement | null, props: InputFieldEditProps) {
    super(element);

    this.props = props;
    this.render();
  }

  private updateBorder() {
    const border = this.node.querySelector('.waykevaluation-input-text');
    if (border) {
      if (this.props.error) {
        border?.classList.add('waykevaluation-input-text--has-error');
      } else {
        border?.classList.remove('waykevaluation-input-text--has-error');
      }
    }
  }

  setError(error: boolean, errorMessage?: string) {
    this.props.error = error;
    if (errorMessage) {
      this.props.errorMessage = errorMessage;
    }
    this.updateBorder();
    this.contexts.error?.setError(error);
  }

  private render() {
    const {
      id,
      title,
      type,
      name,
      value,
      autocomplete,
      placeholder,
      error,
      errorMessage,
      information,
      pattern,
      inputmode,
      disabled,
      readOnly,
      market,
      onChange,
      onBlur,
      onKeyDown,
      onEdit,
      change,
    } = this.props;

    this.node.innerHTML = `
      <div class="waykevaluation-input-label">
        <label for="${id}" class="waykevaluation-input-label__label">${title}</label>
      </div>
      <div class="waykevaluation-input-text${
        readOnly ? ' waykevaluation-input-text--readonly' : ''
      }">
        ${
          market
            ? `
          <div class="waykevaluation-input-text__prefix waykevaluation-input-text__prefix--illustration">
            ${getRegistrationNumberIdentifier(market)}
          </div>
        `
            : ''
        }
        <input
          ${type ? `type="${type}"` : 'type="text"'}
          ${type === 'number' ? `pattern="[0-9]*" inputmode="numeric"` : ''}
          id="${id}"
          ${pattern ? `pattern="${pattern}"` : ''}
          ${inputmode ? `inputmode="${inputmode}"` : ''}
          value="${value}"
          name="${name}"
          ${autocomplete ? `autocomplete="${autocomplete}"` : ''}
          ${placeholder ? `placeholder="${placeholder}"` : ''}
          class="waykevaluation-input-text__input"
          ${disabled ? `disabled=""` : ''}
          ${readOnly ? `readonly=""` : ''}
          
        />
        ${
          onEdit
            ? `
              <div class="waykevaluation-input-text__action">
                <button title="" class="waykevaluation-link">${change}</button>
              </div>
            `
            : ''
        }
      </div>
    `;

    this.updateBorder();
    if (errorMessage) {
      this.contexts.error = new InputError(this.node, {
        error,
        errorMessage,
      });
    }

    if (information) {
      new InputInformation(this.node.querySelector<HTMLElement>('.waykevaluation-input-label'), {
        information,
      });
    }

    const input = this.node.querySelector('input');
    if (input) {
      if (onChange) {
        input.addEventListener('input', onChange);
      }
      if (onBlur) {
        input.addEventListener('blur', onBlur);
      }

      if (onKeyDown) {
        input.addEventListener('keydown', onKeyDown);
      }
    }

    if (onEdit) {
      this.node.querySelector('button')?.addEventListener('click', onEdit);
    }
  }
}

export default InputFieldEdit;
